import { supabase } from '../client/supabaseClient';

/**
 * Marks a print job order as picked up by the user.
 * Updates the status to 'picked-up' in the printjobs table.
 * 
 * @param orderId - The ID of the order to mark as picked up
 * @returns True if successful, false otherwise
 */
export async function markOrderPickedUp(orderId: string): Promise<boolean> {
    try {
        const { error } = await supabase
            .from('printjobs')
            .update({ status: 'picked-up' })
            .eq('id', orderId);

        if (error) {
            console.error('Error marking order as picked up:', error);
            return false;
        }

        return true;
    } catch (error) {
        console.error('Unexpected error in markOrderPickedUp:', error);
        return false;
    }
}
